module.exports = "/images/hailstorm@3x.png?a97409af70bae27c1c701a8ffb5b1fc3";